<div [ngStyle]="getStyle()" id="player"></div>
